import React from 'react'
import { ContractStatus } from 'dealer-types'
import ClockIconSvg from '../other/svg/ClockIconSvg'
import RejectedContractSvg from '../other/svg/RejectedContractIcon'

interface Props {
  contractStatus: ContractStatus
  className?: string
}

const StatusIcon = ({ contractStatus, className = '' }: Props): JSX.Element => {
  if (contractStatus === null) {
    return <div></div>
  }
  return (
    <div className={`w-9 h-9 mx-2 ${className}`}>
      {contractStatus === 'waiting' && <ClockIconSvg className="w-9 h-9" />}
      {contractStatus === 'rejected' && <RejectedContractSvg className="w-32 h-32" />}
    </div>
  )
}

export default StatusIcon
